import { SideButton } from "components/SideButton";
import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";

import { checkForUnexpectedProps } from "services/utility/misc";

const sx = {
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  paddingRight: "1rem",
};

export function SelectButtonCombo(props) {
  const {
    value,
    name,
    onClick,
    onValueChange,
    selectLabel,
    buttonLabel,
    options,
    disableClearable,
    minWidth,
    maxWidth,
    disabled,
    optionDisplayText,
    placeholder,
    ...unexpected
  } = props;
  checkForUnexpectedProps("SelectButtonCombo", unexpected);

  return (
    <div style={{ display: "flex" }}>
      <FrmSelectFromObjects
        name={name}
        label={selectLabel}
        value={value}
        optionDisplayText={optionDisplayText}
        onValueChange={onValueChange}
        options={options}
        InputProps={{ sx }}
        disableClearable={disableClearable}
        maxWidth={maxWidth}
        minWidth={minWidth}
        disabled={disabled}
        placeholder={placeholder}
      />
      <SideButton onClick={onClick} label={buttonLabel} disabled={disabled} />
    </div>
  );
}
